import React from 'react';
import './BlankPage.scss';

const BlankPage = ({ title, description }) => {
  return (
    <div className="blank-page-container">
      <div className="page-header">
        <h1 className="page-title">{title}</h1>
        <p className="page-description">{description}</p>
      </div>
      
      <div className="content-placeholder">
        <p>Content for {title} will be added soon.</p>
      </div>
    </div>
  );
};

export default BlankPage; 